import api from './client';

export const getMyCustomQuotes = () =>
  api.get('/custom-quotes/me').then(r => r.data);

export const acceptCustomQuote = (id) =>
  api.post(`/custom-quotes/${id}/accept`).then(r => r.data);
